/**
 * Formats a given filesize in bytes to a human-readable representation.
 * Optionally, you can also specify how many fraction digits are displayed.
 *
 * @example
 * formatFilesize(1000000)
 * => '1MB'
 * formatFilesize(8675309)
 * => '8.68MB'
 */
export const formatFilesize = (
  filesize?: number | null,
  fractionDigits = 2
) => {
  if (filesize == null) {
    return '0B'
  }

  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(filesize) / Math.log(k))
  return (filesize / Math.pow(k, i)).toFixed(fractionDigits) + sizes[i]
}
